/**************************************************
 * Nombre:       Tarjetas_Producto_Variante
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Tarjetas_Producto_Variante = ({item, click, index}) => {


    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', p: 1, cursor: 'pointer'}}
            spacing={0}
        >


            <Grid container size={4}>
                <Typography
                    sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 16}}>{`${item.nombre}`}</Typography>
            </Grid>

            <Grid container size={4} sx={{mt: 0}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: 12,
                            textOverflow: "ellipsis",
                            lineHeight: 1.1,

                        }}>{`Valor`}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            textOverflow: "ellipsis",

                        }}>{`${formatoMonedaTabla(item.valor)}`}</Typography>
                </Grid>

            </Grid>

            <Grid container size={4} sx={{mt: 0}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: 12,
                            textOverflow: "ellipsis",
                            lineHeight: 1.1

                        }}>{`Descuento`}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            textOverflow: "ellipsis",

                        }}>{`${formatoMonedaTabla(item.valorDescuento)}`}</Typography>
                </Grid>

            </Grid>


        </Grid>


    )

}
export default Tarjetas_Producto_Variante